import { header } from '../../portfolio'
import Navbar from '../Navbar/Navbar'
import './Header.css'
import image from './dive.jpg'


const Header = () => {
  const { homepage, title } = header

  return (
    <header className='header center'>
      <h3>
        {homepage ? (
          <a href={homepage} className='link'>
            {title}
          </a>
        ) : (
          title
        )}
        <img src={image} className='profile' alt='profile'/> 
      </h3>
     
      <Navbar />
    </header>
  )
}

export default Header
